import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { BrowserRouter, Route } from "react-router-dom";
import Login from "./login.js";
import Callbackcreate from "./callbackcreate.js";
import Callbackjoin from "./callbackjoin.js";
import Joingig from "./joingig.js";
import Getgig from "./getgig.js";

ReactDOM.render(
  <BrowserRouter>
    <div>
      <Route exact path="/" component={Login} />
      <Route path="/callbackcreate" component={Callbackcreate} />
      <Route path="/callbackjoin" component={Callbackjoin} />
      <Route path="/joingig" component={Joingig} />
      <Route path="/getgig" component={Getgig} />
    </div>
  </BrowserRouter>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js